<template>
  <v-card-text class="mt-n8 font-weight-bold" v-if="PromocionArt">
    <span
      :class="[
        'text-uppercase logomoneda',
        'mt-0',
        'ml-0',
        
      ]"
    >{{ `${Articulo[0].TipoPrecio} ${simboloMoneda[tipoMoneda]}` }}
      {{
        `${formatMiles({
          value: PromocionArt[0]['PrecioExt-paq'] ,
          numDecimal: 2,
        })}`
      }}
    </span>
    <span :class="['logomoneda text-uppercase']">
      {{ PromocionArt[0].descuento  ? `| Descuento : ${PromocionArt[0].descuento} %` : null }}
    </span>
  </v-card-text>
</template>

<script>
import { formatMiles } from "../../static/funciones";
import { mapState } from "vuex";
export default {
  methods: {
    formatMiles,
  },
  computed: {
    ...mapState([
      "Articulo",
      "simboloMoneda",
      "tipoMoneda",
      "PromocionArt"
    ]),
  },
};
</script>

<style scoped>
.logomoneda {
  font-size: 1.2rem;
  vertical-align: top;
  line-height: 30px;
  margin: 0 5px;
  color: black;
}
</style>
